import {
  ArrowDown,
  ArrowDown01,
  ArrowDown10,
  ArrowDownAZ,
  ArrowDownZA,
  ArrowLeft,
  ArrowRight,
  ArrowRightLeft,
  ArrowUpRight,
  ArrowUp,
  Award,
  Ban,
  BadgeInfo,
  BatteryFull,
  BatteryCharging,
  Blocks,
  Bluetooth,
  Bolt,
  Book,
  BookHeart,
  BotMessageSquare,
  Box,
  Boxes,
  Bug,
  Calendar,
  Camera,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleCheck,
  CircleEqual,
  CircleGauge,
  CircleMinus,
  CirclePlus,
  CircleUserRound,
  CircleX,
  ClipboardCheck,
  Clock,
  Compass,
  Cpu,
  Database,
  DollarSign,
  Droplet,
  Ellipsis,
  EllipsisVertical,
  Equal,
  EqualApproximately,
  ExternalLink,
  Fingerprint,
  Funnel,
  Flame,
  Gem,
  Globe,
  Gpu,
  Grid2x2,
  Grid2x2Plus,
  Hammer,
  HandCoins,
  HandHeart,
  Heart,
  IndianRupee,
  Layers,
  ListTodo,
  LogIn,
  MapPin,
  MapPinXInside,
  MemoryStick,
  MessageSquare,
  MoveDown,
  MoveLeft,
  MoveRight,
  MoveUp,
  NotebookText,
  Navigation,
  Palette,
  Phone,
  Ratio,
  Rocket,
  Rows3,
  Search,
  Settings,
  Shapes,
  Share2,
  ShieldUser,
  ShoppingCart,
  Signal,
  Smartphone,
  SmartphoneNfc,
  SquareEqual,
  SquareRoundCorner,
  Star,
  Store,
  Tag,
  Target,
  TriangleAlert,
  TrendingUp,
  UserRound,
  UserStar,
  UsersRound,
  Usb,
  Wallet,
  Weight,
  Wifi,
  X,

} from "lucide-react";
import DisplaySize from "./Outlined/DisplaySize";
import DisplayType from "./Outlined/DisplayType";
import Downvote from "./Outlined/Downvote";
import DownvoteFilled from "./Filled/DownvoteFilled";
import Sensor from "./Outlined/Sensor";
import StarFilled from "./Filled/StarFilled";
import Upvote from "./Outlined/Upvote";
import UpvoteFilled from "./Filled/UpvoteFilled";
import ForYou from "./Outlined/ForYou";


export const rdAssetIcons = {
  account: UserRound,
  alert: TriangleAlert,
  arrowDown: ArrowDown,
  arrowDownLong: MoveDown,
  arrowLeft: ArrowLeft,
  arrowLeftLong: MoveLeft,
  arrowRight: ArrowRight,
  arrowRightLong: MoveRight,
  arrowUp: ArrowUp,
  arrowUpLong: MoveUp,
  arrowUpRight: ArrowUpRight,
  article: NotebookText,
  askBot: BotMessageSquare,
  batteryCharge: BatteryCharging,
  battery: BatteryFull,
  brand: Award,
  browse: Book,
  bug: Bug,
  bluetooth: Bluetooth,
  budgetMatch: Wallet,
  buildQuality: Hammer,
  call: Phone,
  camera: Camera,
  cancel: CircleX,
  category: Boxes,
  chat: MessageSquare,
  check: Check,
  close: X,
  color: Palette,
  community: UsersRound,
  compare: ArrowRightLeft,
  cpu: Cpu,
  dimension: Ratio,
  displaySize: DisplaySize,
  displayType: DisplayType,
  discontinued: Ban,
  dollar: DollarSign,
  downvote: Downvote,
  downvoteSelected: DownvoteFilled,
  dropdownArrowDown: ChevronDown,
  dropdownArrowLeft: ChevronLeft,
  dropdownArrowRight: ChevronRight,
  dropdownArrowUp: ChevronUp,
  duration: Clock,
  explore: Compass,
  externalLink: ExternalLink,
  favoriteProduct: BookHeart,
  feature: Blocks,
  featureLibrary: Grid2x2,
  filter: Funnel,
  findStore: ShoppingCart,
  forYou: ForYou,
  gps: MapPin,
  gpu: Gpu,
  helpCenter: HandHeart,
  information: BadgeInfo,
  keyword: Tag,
  lookFeel: SquareRoundCorner,
  minus: CircleMinus,
  moreHorizontal: Ellipsis,
  moreVertical: EllipsisVertical,
  network: Signal,
  navigation: Navigation,
  nfc: SmartphoneNfc,
  notification: CircleCheck,
  noLocationAccess: MapPinXInside,
  os: Layers,
  performance: CircleGauge,
  phone: Smartphone,
  plus: CirclePlus,
  popular: Flame,
  price: HandCoins,
  primeMatch: Gem,
  product: Box,
  productUpvote: Heart,
  productOverview: Target,
  profile: CircleUserRound,
  profileSecure: ShieldUser,
  ram: MemoryStick,
  rating: Star,
  ratingSelected: StarFilled,
  releaseDate: Calendar,
  requestFeature: Grid2x2Plus,
  reviewSummary: UserStar,
  rupee: IndianRupee,
  search: Search,
  sensor: Sensor,
  sensorFingerprint: Fingerprint,
  setting: Settings,
  share: Share2,
  signIn: LogIn,
  sortAlphabetAsc: ArrowDownAZ,
  sortAlphabetDesc: ArrowDownZA,
  sortNumberAsc: ArrowDown01,
  sortNumberDesc: ArrowDown10,
  spec: ListTodo,
  specAbout: EqualApproximately,
  specAdvanced: CircleEqual,
  specBasic: Equal,
  specLibrary: Rows3,
  specPremium: SquareEqual,
  status: ClipboardCheck,
  storage: Database,
  store: Store,
  trend: TrendingUp,
  upcoming: Rocket,
  upvote: Upvote,
  upvoteSelected: UpvoteFilled,
  url: Globe,
  usb: Usb,
  shopPref: Bolt,
  variant: Shapes,
  waterproof: Droplet,
  weight: Weight,
  wifi: Wifi
};